/**
 * Translates only the word parts of a string, leaving any numbers unaltered.
 * @param input - The input string containing words and numbers.
 * @param t - The translation function from `react-i18next`.
 * @returns The translated string with only words translated, numbers are untouched.
 *
 * @example const { t } = useTranslation();
 *          translateWordsOnly("1 Week", t) // Output: "1 TranslatedWeek"
 */
export function translateWordsOnly(
  input: string,
  t: (key: string) => string
): string {
  return input
    .split(' ') // Split the input into separate words
    .map((word) => {
      // Check if the word is a number
      if (!isNaN(Number(word))) {
        return word; // Leave numbers unaltered
      } else {
        return t(word); // Translate words
      }
    })
    .join(' '); // Join the translated words back into a single string
}
